<template>
  <Modal>
    <div slot="header">
      <div class="modal-header__content">
        <div class="modal-header__player">
          <h3 class="text-bold text-lg mb-8 text-white">Add note</h3>
          <div class="modal__player">
            <profile-pic
              v-show="false"
              :src="player.player.photo_url"
              :alt="player.player.name"
              :size="40" />
            <div class="text-bold">{{ player.player.name }}</div>
          </div>
        </div>
        <button class="modal-header__close" @click="toggle">
          <svg-icon icon="x"></svg-icon>
        </button>
      </div>
    </div>
    <div slot="body">
      <NoteForm
        :player="{ id: player.player.id }"
        :playerLineupId="player.id"
        @noteAdded="toggle" />
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/Modal';
  import NoteForm from '@/components/Forms/NoteForm';

  export default {
    name: 'NoteModal',
    components: { NoteForm, Modal },
    props: {
      player: {
        required: true,
      },
      toggle: {
        type: Function,
        required: true,
      },
    },
  };
</script>
